module.exports = __webpack_public_path__ + "media/images/shopping-cart_wt-01712fc5497f611bc3ee299a0577227e.png";